import axios from "axios";
import { message } from "antd";

const apiUrl = process.env.REACT_APP_API_URL;

export const get_recurrencies = async (token, type, company_id, position) => {
	const body = {
		token,
		type,
		company_id,
		position
	};

	try {
		const res = await axios.post(`${apiUrl}/get_recurrencies`, body);
		return res.data;
	} catch (err) {
		message.error(err.response.data);
		throw err;
	}
};

export const create_recurrency = async (token, type, company_id, specs, position) => {
	const body = {
		token,
		edit_value: "create",
		data: {
			type,
			specs,
			company_id,
			position
		}
	};

	try {
		const res = await axios.post(`${apiUrl}/edit_recurrency`, body);
		return res.data;
	} catch (err) {
		message.error(err.response.data);
		throw err;
	}
};

export const edit_recurrency = async (token, id, type, specs) => {
	const body = {
		token,
		edit_value: "edit",
		data: {
			id,
			type,
			specs,
		}
	};

	try{
		const res = await axios.post(`${apiUrl}/edit_recurrency`, body);
		return res.data;
	} catch (err) {
		message.error(err.response.data);
		throw err;
	}
};

export const toggle_recurrency = async (token, id) => {
	let body = {
		token,
		edit_value: "toggle_activation",
		data: {
			id
		}
	};

	try {
		const res = await axios.post(`${apiUrl}/edit_recurrency`, body);
		if (res) {
			message.success(res.data);
		}
		return res.data;
	} catch (err) {
		message.error(err.response.data);
		throw err;
	}
};